export function toggleAccordion(elem) {
   elem.addEventListener('click', () => {
      if (elem.getAttribute('aria-expanded') === 'false') {
         elem.setAttribute('aria-expanded', 'true');
         elem.parentElement
            .querySelectorAll('.event_accordion_list')
            .forEach((list) => {
               list.classList.remove('hidden');
               list.setAttribute('aria-expanded', 'true');
            });
      } else {
         elem.setAttribute('aria-expanded', 'false');
         elem.parentElement
            .querySelectorAll('.event_accordion_list')
            .forEach((list) => {
               list.classList.add('hidden');
               list.setAttribute('aria-expanded', 'false');
            });
      }
   });
}
